module.exports = __webpack_public_path__ + "static/media/qr_code.11deaeca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr_code.svg
// module id = 3694
// module chunks = 0